<template>
    <span> Good {{ greeting }} </span>
</template>
<script>
export default {
    data: () => ({
        greeting: 'Morning',
    }),
    methods: {
        setMorningAfternoon() {
            const today = new Date();
            const curHr = today.getHours();
            if (curHr < 12) {
                this.greeting = 'Morning';
            } else if (curHr < 18) {
                this.greeting = 'Afternoon';
            } else {
                this.greeting = 'Evening';
            }
        },
    },
    mounted() {
        this.setMorningAfternoon();
        setInterval(() => {
            this.setMorningAfternoon();
        }, 10000);
    },
};
</script>
